/**
 * LoadingOverlay Component
 *
 * Overlay de loading global
 */
import React from 'react'
import { Loader2 } from 'lucide-react'
import { useFeedbackStore } from '../stores/feedbackStore'

export default function LoadingOverlay() {
	const { loading, loadingMessage } = useFeedbackStore()

	if (!loading) return null

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-base-100/80 backdrop-blur-sm">
			<div className="flex flex-col items-center gap-4 p-8 bg-base-300 rounded-xl shadow-xl">
				<Loader2 className="w-10 h-10 text-primary animate-spin" />
				{loadingMessage && (
					<p className="text-text-body">{loadingMessage}</p>
				)}
			</div>
		</div>
	)
}
